(() => {
  const reducedMotion = matchMedia('not all');
  const setupReviews = (scope = document) => {
    scope.querySelectorAll('.rr-product-apps .jdgm-review-widget').forEach(widget => {
      if (widget.dataset.rrCompact) return;
      widget.dataset.rrCompact = 'true';
      let frame;
      const enhance = () => {
        const row = widget.querySelector('.jdgm-row-stars');
        const histogram = row?.querySelector('.jdgm-histogram');
        if (histogram) histogram.hidden = false;
        row?.querySelector('.rr-rating-toggle')?.remove();
        widget.querySelectorAll('.jdgm-rev__body').forEach((body, index) => {
          if (body.dataset.rrExpandable || body.querySelector('a,button')) return;
          const lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 22.4;
          if (body.scrollHeight <= lineHeight * 3 + 4) return;
          body.dataset.rrExpandable = 'true';
          body.id ||= 'rr-review-body-' + (body.closest('[data-review-id]')?.dataset.reviewId || index);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rr-review-expand';
          button.textContent = 'Read more';
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-controls', body.id);
          body.classList.add('rr-review-clamped');
          button.addEventListener('click', () => {
            const collapsed = body.classList.toggle('rr-review-clamped');
            button.setAttribute('aria-expanded', String(!collapsed));
            button.textContent = collapsed ? 'Read more' : 'Read less';
          });
          body.after(button);
        });
        widget.querySelectorAll('.jdgm-rev').forEach(review => {
          const icon = review.querySelector('.jdgm-rev__icon');
          const author = review.querySelector('.jdgm-rev__author')?.textContent.trim();
          if (!icon || !author || icon.dataset.rrAvatar) return;
          let hash = 0;
          for (const character of author) hash = ((hash << 5) - hash + character.charCodeAt(0)) | 0;
          const avatar = Math.abs(hash) % 6;
          icon.dataset.rrAvatar = String(avatar);
          icon.style.setProperty('--rr-review-avatar', `var(--rr-review-avatar-${avatar})`);
          icon.setAttribute('aria-hidden', 'true');
        });
      };
      const queue = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(enhance); };
      const observer = new MutationObserver(queue);
      observer.observe(widget, {childList:true, subtree:true});
      const resize = new ResizeObserver(queue);
      resize.observe(widget);
      const rememberFilterState = event => {
        const row = event.target.closest('.jdgm-histogram__row:not(.jdgm-histogram__clear-filter)');
        if (row) row.dataset.rrWasSelected = String(row.classList.contains('jdgm-histogram__row--selected'));
      };
      widget.addEventListener('pointerdown', rememberFilterState, true);
      widget.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') rememberFilterState(event);
      }, true);
      widget.addEventListener('click', event => {
        const row = event.target.closest('.jdgm-histogram__row:not(.jdgm-histogram__clear-filter)');
        if (!row || row.dataset.rrWasSelected !== 'true') return;
        const clearFilter = widget.querySelector('.jdgm-histogram__clear-filter');
        if (!clearFilter) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        clearFilter.click();
      }, true);
      enhance();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(widget)) { observer.disconnect(); resize.disconnect(); cancelAnimationFrame(frame); }
      });
    });
    scope.querySelectorAll('.rr-product-rating .jdgm-prev-badge').forEach(badge => {
      if (badge.dataset.rrLink || !document.getElementById('rr-reviews')) return;
      badge.dataset.rrLink = 'true';
      badge.tabIndex = 0;
      badge.setAttribute('role', 'link');
      badge.setAttribute('aria-label', 'Read customer reviews');
      const go = event => {
        event.preventDefault();
        const section = document.getElementById('rr-reviews');
        section.scrollIntoView({behavior:reducedMotion.matches ? 'instant' : 'smooth'});
        section.focus({preventScroll:true});
      };
      badge.addEventListener('click', go);
      badge.addEventListener('keydown', event => { if (event.key === 'Enter') go(event); });
    });
  };
  setupReviews();
  document.addEventListener('shopify:section:load', event => setupReviews(event.target));

  const openShopifyChat = () => {
    const chat = document.querySelector('shopify-chat');
    const activator = chat?.shadowRoot?.querySelector('[part~="activator"]');
    if (!activator) return false;
    if (activator.getAttribute('aria-expanded') !== 'true') activator.click();
    return true;
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-rr-chat-open]');
    if (!trigger) return;
    event.preventDefault();
    if (openShopifyChat()) return;
    let attempts = 0;
    const waitForInbox = setInterval(() => {
      attempts += 1;
      if (openShopifyChat() || attempts >= 20) clearInterval(waitForInbox);
    }, 150);
  });

  const initWelcome = () => {
    const root = document.querySelector('[data-rr-welcome]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('dialog');
    if (!dialog.showModal) return;
    const teaser = root.querySelector('[data-rr-treat-open]');
    const form = root.querySelector('form');
    const demo = root.dataset.demo === 'true';
    const emailDelivery = root.dataset.delivery === 'email';
    const galaxy = root.querySelector('[data-rr-galaxy]');
    const tiltButton = root.querySelector('[data-rr-tilt]');
    const clamp = value => Math.max(-1, Math.min(1, value));
    const moveSky = (x, y) => {
      dialog.style.setProperty('--sky-x', `${clamp(x) * 12}px`);
      dialog.style.setProperty('--sky-y', `${clamp(y) * 10}px`);
    };
    dialog.addEventListener('pointermove', event => {
      if (event.pointerType !== 'mouse') return;
      const box = dialog.getBoundingClientRect();
      moveSky((event.clientX - box.left) / box.width * 2 - 1, (event.clientY - box.top) / box.height * 2 - 1);
    });
    dialog.addEventListener('pointerleave', () => moveSky(0, 0));
    let baseline;
    let sensorActive = false;
    const tilt = event => {
      if (!dialog.open || event.beta == null || event.gamma == null) return;
      baseline ||= {beta:event.beta, gamma:event.gamma};
      const angle = (screen.orientation?.angle || 0) * Math.PI / 180;
      const x = (event.gamma - baseline.gamma) / 20;
      const y = (event.beta - baseline.beta) / 20;
      moveSky(x * Math.cos(angle) + y * Math.sin(angle), y * Math.cos(angle) - x * Math.sin(angle));
    };
    const startSensor = () => {
      if (sensorActive) return;
      sensorActive = true;
      window.addEventListener('deviceorientation', tilt, {passive:true});
    };
    if (matchMedia('(pointer:coarse)').matches && window.isSecureContext && window.DeviceOrientationEvent) {
      if (typeof DeviceOrientationEvent.requestPermission === 'function') tiltButton.hidden = false;
      else startSensor();
    }
    tiltButton.addEventListener('click', async () => {
      try {
        if (await DeviceOrientationEvent.requestPermission() === 'granted') {
          startSensor();
          tiltButton.hidden = true;
        } else tiltButton.textContent = 'Tilt access not enabled';
      } catch { tiltButton.textContent = 'Tilt unavailable'; }
    });
    dialog.addEventListener('close', () => { baseline = null; moveSky(0, 0); });
    const read = (key, storage = 'localStorage') => { try { return JSON.parse(window[storage].getItem(key)); } catch { return null; } };
    const write = (key, value, storage = 'localStorage') => { try { window[storage].setItem(key, JSON.stringify(value)); } catch { /* Storage can be disabled. */ } };
    const day = 86400000;
    const quietDays = Math.max(7, Math.min(90, Number(root.dataset.quietDays || 30)));
    const starCount = root.querySelectorAll('[data-rr-star]').length;
    const fortunes = [
      'May something you’ve quietly wished for find you today.',
      'A small surprise is waiting to brighten your day.',
      'Something lovely may find you when you least expect it.',
      'Let one small joy be enough for today.',
      'Take your time. Good things are finding their way to you.'
    ];
    let selected = false;
    let opened = false;
    let complete = false;
    const legacyDismissed = Number(read('rr-treat-dismissed') || 0);
    let quietUntil = Number(read('rr-treat-quiet-until') || 0);
    if (!quietUntil && legacyDismissed) quietUntil = legacyDismissed + quietDays * day;
    const isQuiet = () => Date.now() < quietUntil;
    const startQuietPeriod = (days = quietDays) => {
      quietUntil = Date.now() + days * day;
      write('rr-treat-quiet-until', quietUntil);
    };
    const claimed = Date.now() - Number(read('rr-treat-claimed') || 0) < 365 * day;
    let previousFocus;
    const analytics = name => {
      if (!demo) window.Shopify?.analytics?.publish?.(name, {campaign:'welcome-game-10'});
    };
    const show = (manual = false) => {
      if (dialog.open) return;
      if (!manual) startQuietPeriod();
      previousFocus = document.activeElement;
      dialog.showModal();
      document.body.classList.add('rr-treat-open');
      teaser.hidden = true;
      opened = true;
      analytics('rr_welcome_view');
    };
    const close = () => dialog.close();
    root.querySelectorAll('[data-rr-treat-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => { if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    } });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('rr-treat-open');
      startQuietPeriod();
      teaser.hidden = complete || claimed;
      if (previousFocus?.isConnected && previousFocus !== document.body) previousFocus.focus({preventScroll:true});
      else if (!teaser.hidden) teaser.focus({preventScroll:true});
    });
    teaser.addEventListener('click', () => show(true));

    const pick = (index, restore = false) => {
      if (selected || !Number.isInteger(index) || index < 0 || index >= starCount) return;
      selected = true;
      dialog.classList.add('has-picked-star');
      root.querySelectorAll('[data-rr-star]').forEach((star, n) => {
        star.disabled = true;
        star.classList.add(n === index ? 'is-picked' : 'is-muted');
        star.setAttribute('aria-pressed', String(n === index));
      });
      root.querySelector('[data-rr-galaxy]').classList.add('has-selection');
      const chosenStar = root.querySelector(`[data-rr-star="${index}"]`);
      const starMessage = root.querySelector('[data-rr-star-message]');
      root.querySelector('[data-rr-star-message-copy]').textContent = fortunes[index];
      chosenStar.append(starMessage);
      root.querySelector('[data-rr-pick-title]').hidden = true;
      root.querySelector('[data-rr-pick-intro]').hidden = true;
      root.querySelector('[data-rr-win-title]').hidden = false;
      root.querySelector('[data-rr-win-intro]').hidden = false;
      root.querySelector('.rr-treat-eyebrow').textContent = 'YOUR LUCKY STAR';
      starMessage.hidden = false;
      dialog.classList.add('is-revealing');
      const reveal = () => {
        root.querySelector('[data-rr-conversion]').hidden = false;
        root.querySelector('[data-rr-claim]').hidden = false;
        requestAnimationFrame(() => dialog.classList.add('is-ready'));
        if (!restore && dialog.open) root.querySelector('[data-rr-heading]').focus({preventScroll:true});
      };
      if (restore || reducedMotion.matches) reveal();
      else setTimeout(reveal, 700);
      startQuietPeriod();
      write('rr-treat-star', index, 'sessionStorage');
    };
    root.querySelectorAll('[data-rr-star]').forEach(star => star.addEventListener('click', () => pick(Number(star.dataset.rrStar))));

    const reward = () => {
      complete = true;
      root.querySelector('[data-rr-reward]').hidden = false;
      root.querySelector('[data-rr-code]').textContent = demo ? 'PREVIEW' : root.dataset.discount;
      const shop = root.querySelector('[data-rr-shop]');
      if (!demo) {
        if (!emailDelivery) shop.href = (window.Shopify?.routes?.root || '/') + 'discount/' + encodeURIComponent(root.dataset.discount) + '?redirect=' + encodeURIComponent(shop.getAttribute('href'));
        write('rr-treat-claimed', Date.now());
        startQuietPeriod(365);
        analytics('rr_welcome_signup_success');
      }
      root.querySelector('[data-rr-copy]').hidden = demo || emailDelivery;
      if (demo) form.hidden = true;
    };
    const previewSubmit = form?.querySelector('[type=submit]');
    if (demo && previewSubmit) {
      // Explicit demo path: no POST, no contact data, and no valid coupon.
      form.querySelectorAll('input:not([type=hidden])').forEach(input => { input.disabled = true; input.required = false; });
      previewSubmit.type = 'button';
      previewSubmit.textContent = 'Sign up →';
      previewSubmit.addEventListener('click', reward);
    }
    form?.addEventListener('submit', event => {
      if (demo) { event.preventDefault(); return; }
      // Native Shopify customer POST retains spam protection and server validation.
      // Never infer success from HTTP 200 or an arbitrary URL query parameter.
      write('rr-treat-pending', Date.now(), 'sessionStorage');
    });
    root.querySelector('[data-rr-copy]').addEventListener('click', async event => {
      try {
        await navigator.clipboard.writeText(root.dataset.discount);
        event.target.textContent = 'Copied!';
        analytics('rr_welcome_code_copy');
      } catch { event.target.textContent = 'Select code to copy'; }
    });
    root.querySelector('[data-rr-shop]').addEventListener('click', () => analytics('rr_welcome_shop_click'));
    const pending = Number(read('rr-treat-pending', 'sessionStorage') || 0);
    const returning = pending > 0 && Date.now() - pending < 30 * 60000;
    if (!demo && returning && (root.querySelector('[data-rr-server-success]') || root.querySelector('[data-rr-server-error]'))) {
      const saved = read('rr-treat-star', 'sessionStorage');
      pick(Number.isInteger(saved) && saved >= 0 && saved < starCount ? saved : 0, true);
      show(true);
      if (root.querySelector('[data-rr-server-success]')) { reward(); write('rr-treat-pending', null, 'sessionStorage'); }
    } else {
      const reviewPreview = demo && new URLSearchParams(location.search).get('rr_game') === 'preview';
      if (reviewPreview) show(true);
      else if (!claimed) teaser.hidden = false;
    }
    let elapsed = false;
    const busy = () => document.hidden || document.body.matches('.menu-open,.rr-cart-drawer-open') ||
      !!document.querySelector('dialog[open],[data-rr-cart-drawer][aria-hidden="false"],[data-mega][open]') ||
      !!document.activeElement?.closest('input,textarea,select,iframe');
    const maybeOpen = () => {
      if (demo || opened || claimed || isQuiet() || !elapsed || window.Shopify?.designMode || busy()) return;
      const available = document.documentElement.scrollHeight - innerHeight;
      if (available > 0 && scrollY / available >= .3) show();
    };
    const delay = setTimeout(() => { elapsed = true; maybeOpen(); }, Number(root.dataset.delay || 12) * 1000);
    document.addEventListener('scroll', maybeOpen, {passive:true});
    document.addEventListener('focusout', maybeOpen);
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      clearTimeout(delay);
      window.removeEventListener('deviceorientation', tilt);
      if (dialog.open) close();
      document.removeEventListener('scroll', maybeOpen);
      document.removeEventListener('focusout', maybeOpen);
    });
  };
  initWelcome();
  document.addEventListener('shopify:section:load', initWelcome);
})();
